import React from 'react';
import { Reveal } from '../Reveal';
import { TestimonialCard } from '../TestimonialCard';
import { testimoniosIniciales } from '../../data/content';
export function TestimoniosIniciales() {
  return <section aria-label="Testimonios de profes" className="w-full bg-grisclaro px-4 py-14 sm:px-6 sm:py-16" data-id="element-264" data-mp="8a2a4iranh4z">
      <div className="mx-auto max-w-3xl" data-id="element-265" data-mp="3br28dkk7gpe">
        <div className="flex flex-col gap-5 sm:gap-6" data-id="element-266" data-mp="3cslv6fn5biq">
          {testimoniosIniciales.map((testimonio, index) => <Reveal key={testimonio.name} delay={Math.min(index, 2) * 0.05} data-id="element-267" data-mp="36reod4h8krko" data-mpi={index}>
              <TestimonialCard testimonio={testimonio} data-id="element-268" data-mp="36tj20e4xt4y5" />
            </Reveal>)}
        </div>
      </div>
    </section>;
}